import "./VocabTooltip.css";
import "./QuestJournalSearchScope.css";

const DEFAULT_SCOPE_OPTIONS = [
  {
    id: "title",
    letter: "T",
    tooltip: "Rechercher dans le titre de la quête",
  },
  {
    id: "content",
    letter: "C",
    tooltip: "Rechercher dans le contenu de la quête",
  },
];

export default function QuestJournalSearchScope({
  value = "title",
  onChange = () => {},
  name = "quest-journal-search-scope",
  titleTooltip = DEFAULT_SCOPE_OPTIONS[0].tooltip,
  contentTooltip = DEFAULT_SCOPE_OPTIONS[1].tooltip,
  options,
  legend = "Zone de recherche",
}) {
  const scopeOptions =
    Array.isArray(options) && options.length
      ? options
      : [
          { ...DEFAULT_SCOPE_OPTIONS[0], tooltip: titleTooltip },
          { ...DEFAULT_SCOPE_OPTIONS[1], tooltip: contentTooltip },
        ];

  return (
    <fieldset className="quest-journal-search-scope">
      <legend className="quest-journal-search-scope__legend">{legend}</legend>
      {scopeOptions.map((option) => {
        const tooltipId = `${name}-${option.id}`;
        const isChecked = value === option.id;

        return (
          <label
            key={option.id}
            className={`quest-journal-search-scope__option${
              isChecked ? " quest-journal-search-scope__option--active" : ""
            }`}
          >
            <span
              className="quest-journal-search-scope__letter vocab-tooltip-wrap"
              tabIndex={0}
              aria-describedby={tooltipId}
            >
              {option.letter}
              <span
                id={tooltipId}
                className="vocab-tooltip vocab-tooltip--below quest-journal-search-scope__tooltip"
                role="tooltip"
              >
                {option.tooltip}
              </span>
            </span>
            <span className="quest-journal-search-scope__radio">
              <input
                type="radio"
                className="quest-journal-search-scope__radio-input"
                name={name}
                value={option.id}
                checked={isChecked}
                onChange={() => onChange(option.id)}
              />
              <span className="quest-journal-search-scope__radio-dot" aria-hidden="true" />
            </span>
          </label>
        );
      })}
    </fieldset>
  );
}
